import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor';
import { PublicInterceptor } from '../../../Base/interceptors/PublicInterceptor';

import { decodeToken } from "react-jwt";

// ACCESO DEL USUARIO CON PERMISO 5 DE LOS BOTONES
export const permisosByUsuarioBotones = async(Usuario) => {
    const result = await PrivateInterceptor('IT/Accesos/PermisosBotones', 'POST',{
        Usuario : Usuario
    });
    return (result[0]?.acceso === 1 ? true : false);
}

// ACCESO DEL USUARIO CON PERMISO 4 DE COSTOS 
export const permisosByUsuario = async(Usuario) => {
    const result = await PrivateInterceptor('IT/Accesos/PermisosCostos', 'POST',{
        Usuario : Usuario
    });
    return (result[0]?.acceso === 1 ? true : false);
}

// GET LISTADO DE ACCESOS DE UN USUARIO
export const getAccesosWebUser = async (idUser) => {
    const result = await PrivateInterceptor(`IT/Accesos`, 'GET');
    return result;
 }

 // GET LISTADO DE ACCESO POR MENU
export const getListAccesoMenu = async () => {
    const result = await PrivateInterceptor('IT/Accesos/AccessGroup', 'GET');
    return result;
 }

 // UPDATE LISTADO DE ACCESOS DE UN USUARIO
export const updateEstadoAccesoWeb = async (data) => {
    const result = await PrivateInterceptor(`IT/Accesos/changeEstado`, 'POST', data);
    return result;
 }

 // UPDATE AND CREATE ACCESO
export const IUAccesoWebUser = async (data) => {
    const result = await PrivateInterceptor(`IT/Accesos/update`, 'POST', data);
    return result;
 }

 export const authByUserOrRol = async (data) => {
    const result = await PrivateInterceptor(`Accesos/ByUserOrRol`, 'POST', data);
    return result;
 }
 

 export const AccesoUser = async (data) => {
    const result = await PrivateInterceptor(`Accesos/User`, 'POST', data);
    return result;
 }
 

 
 export const getPublicAccesosWebUser = async (idUser, token) => {
    const user = token ? decodeToken(token) : JSON.parse(localStorage.getItem('TokenPPF'))
    let id = idUser ? idUser : user.idUser
    const result = await PublicInterceptor(`AccesosUser/user/${id}`, 'GET', {}, token);
    return result;
 }


 
export const UsuariosConAcceso = async (IdAcceso) => {
    const result = await PrivateInterceptor(`IT/Accesos//UsuariosConAcceso`, 'POST', {IdAcceso});
    return result;
}